import { api } from './api';

/**
 * Retrieve medications for a patient.
 * @param {string} patientUUID - The unique identifier of the patient.
 * @param {boolean} onlyStarted - Return only started medications.
 * @param {boolean} includeArchived - Include archived medications.
 */
export const getPatientMedications = async (
    patientUUID,
    onlyStarted = false,
    includeArchived = false
) => {
    const response = await api.post('/cheart/medications', {
        patient: patientUUID,
        only_started: onlyStarted,
        include_archived: includeArchived
    });
    return response.data;
};

/**
 * Fetch a medication by UUID.
 * @param {string} uuid - The unique identifier of the medication.
 */
export const fetchMedicationByUUID = async (uuid) => {
    const response = await api.post('/cheart/medications/fetch', { uuid });
    return response.data;
};

/**
 * Start a medication treatment.
 * @param {string} uuid - The unique identifier of the medication.
 * @param {string|null} ts - Optional ISO timestamp to start the medication.
 */
export const startMedication = async (uuid, ts = null) => {
    const payload = { uuid };

    if (ts) {
        payload.ts = ts;
    }

    const response = await api.post('/cheart/medications/start', payload);
    return response.data;
};

/**
 * Create a new medication for a patient.
 * (Doctor / Care Giver only)
 * @param {string} patientUUID - Patient UUID.
 * @param {string} name - Medication name.
 * @param {string} appearance - Appearance type (ENUM key).
 * @param {string} dosage - Dosage description.
 * @param {string} duration - Treatment duration.
 * @param {string} notes - Additional notes.
 */
export const createMedication = async ({
    patientUUID,
    name,
    appearance,
    dosage,
    duration,
    notes
}) => {
    const response = await api.post('/cheart/medications/admin', {
        patient: patientUUID,
        name,
        appearance,
        dosage,
        duration,
        notes
    });
    return response.data;
};

/**
 * Archive (soft-delete) a medication.
 * (Doctor / Care Giver only)
 * @param {string} uuid - The unique identifier of the medication.
 */
export const deleteMedication = async (uuid) => {
    const response = await api.delete('/cheart/medications/admin', {
        data: { uuid }
    });
    return response.data;
};
